var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63548 0C9.03298 0 8.54457 0.488392 8.54457 1.09091V16.9091C8.54457 17.5116 9.03298 18 9.63548 18H12.3628C12.9652 18 13.4537 17.5116 13.4537 16.9091V1.09091C13.4537 0.488392 12.9652 0 12.3628 0H9.63548Z",
    fill: "#5D688B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1809 5.45455C16.1809 4.85203 16.6693 4.36364 17.2718 4.36364H19.9991C20.6016 4.36364 21.09 4.85203 21.09 5.45455V16.9091C21.09 17.5116 20.6016 18 19.9991 18H17.2718C16.6693 18 16.1809 17.5116 16.1809 16.9091V5.45455Z",
    fill: "#5D688B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.908203 10.3636C0.908203 9.76112 1.39662 9.27273 1.99911 9.27273H4.72639C5.32888 9.27273 5.81729 9.76112 5.81729 10.3636V16.9091C5.81729 17.5116 5.32888 18 4.72639 18H1.99911C1.39662 18 0.908203 17.5116 0.908203 16.9091V10.3636Z",
    fill: "#5D688B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavInvestment);
export default __webpack_public_path__ + "static/media/nav-investment.3c7f6ca7.svg";
export { ForwardRef as ReactComponent };